export const specificParkingDataSelector = ({specificParkingData}) => specificParkingData